import React from "react";
import './styles.scss'

import {Text} from '@mantine/core';
import { useShipmentLogisticsMilestones } from "../../../api/Shipment.Milestones/Shipment.Milestones.hooks";
import ShipmentTimeline from "../Shipment.timeline/Shipment.timeline";

interface Props {
    referenceNumber?: string
}

function ShipmentLogisticsMilestones ({referenceNumber}: Props) {
    const {isLoading, data} = useShipmentLogisticsMilestones({referenceNumber})

    if(isLoading || !data)
    {
        return (<div>Loading...</div>);
    }

    return (
        <div className="milestones-logistics">
            <Text size="lg" color="gray" align="center">Logistics</Text>
            <div style={{marginTop:24}}> 
                <ShipmentTimeline milestones={data}></ShipmentTimeline>
            </div>
        </div>
    )
}

export default ShipmentLogisticsMilestones;